import React from "react";
import { useState } from "react";
import { useEffect } from "react";
import { useTranslation, withTranslation } from "react-i18next";
import { urlOriginal } from "../../common/config";
import { policy } from "../../services";

const service = policy;

const PolicyAndGeneralTermDetail = (props: any) => {
  const { match } = props;
  const { t } = useTranslation();
  const [html, setHtml] = useState("");
  const _type = t(match.params?.type) || "";

  useEffect(() => {
    if (_type) {
      service.getPolicy(_type, (data: any, err: any) => {
        if (data) {
          setHtml(
            data.replace(
              /src="images|src="\/images/gi,
              `src="${urlOriginal}images`
            )
          );
        }
      });
    }
  }, [match.url]);

  return html ? (
    <div className="policy-detail-wrap">
      <div
        dangerouslySetInnerHTML={{
          __html: html,
        }}></div>
    </div>
  ) : (
    <></>
  );
};

export default withTranslation()(PolicyAndGeneralTermDetail);
